import router from "@/router";
import store from "@/store";
import axios from "axios";
import AzureAuthService from "../AzureAuthService";
import UserService from "../UserService";
import OfflineQueueService from "@/services/OfflineQueueService";

export const ErrorInterceptor = async (error) => {

  if (error.response) {

    const originalRequest = error.config;
    const hasSession = typeof localStorage !== "undefined"
      && (localStorage.getItem("token") || localStorage.getItem("user"));
    const queuedAuthRequest = error.response.status === 403
      && originalRequest
      && hasSession
      && OfflineQueueService.enqueue(originalRequest);

    if (queuedAuthRequest) {
      store.dispatch("app/showOfflineSaved");
    }

    // if (error.response.status === 403 && !originalRequest._retry) {

    //   console.log("1");
    //   await AzureAuthService.refreshToken();

    //   if (originalRequest.url == "my/profile/") {
    //     console.log("2");
    //     store.dispatch("app/showValidationError", { response: { data: { error: ["Du har blivit utloggad. Logga in igen"] } } });
    //     store.dispatch("auth/clear");

    //     router.push({ name: "login", query: { nextUrl: router.currentRoute.path } });
    //   }
    //   // else {
    //   //   console.log("3");
    //   //   UserService.getMyProfile()
    //   //     .then((user) => {
    //   //       originalRequest._retry = true;
    //   //       return axios(originalRequest);
    //   //     }).catch((error) => {
    //   //     })
    //   // }
    // }
    // else
    if (error.response.status === 401 || error.response.status === 403 && originalRequest.url != "devices") {
      console.log("4");

      if (!queuedAuthRequest) {
        store.dispatch("app/showValidationError", { response: { data: { error: ["Du har inte tillåtelse att se det här"] } } });
      }
      store.dispatch("auth/clear");

      if(router.currentRoute.path != "/login"){
        router.push({ name: "login", query: { nextUrl: router.currentRoute.path } });
      }

    } else if (error.response.status === 400) {
      console.log("7");
      store.dispatch("app/showValidationError", error);
    }

    return Promise.reject(error);
  } else {
    store.commit("app/setConnected", false);
    const originalRequest = error.config;

    const isLoginRequest = originalRequest && originalRequest.url && (
      originalRequest.url.includes("rest-auth/login/") ||
      originalRequest.url.includes("rest-auth/logout/")
    );

    if (!isLoginRequest && originalRequest && OfflineQueueService.enqueue(originalRequest)) {
      store.dispatch("app/showOfflineSaved");
      return Promise.resolve(OfflineQueueService.buildOfflineResponse(originalRequest));
    }

    return Promise.reject(error);
  }
};

export default ErrorInterceptor;
